import { render } from "./ProductsMarket.vue?vue&type=template&id=c2e43a26"
import script from "./ProductsMarket.vue?vue&type=script&lang=js"
export * from "./ProductsMarket.vue?vue&type=script&lang=js"

import "./ProductsMarket.vue?vue&type=style&index=0&id=c2e43a26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__